export default __webpack_public_path__ + "assets/uv-index-5.f269b842.svg";